//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AppSidebar from '@nextcloud/vue/dist/Components/AppSidebar';
import Actions from '@nextcloud/vue/dist/Components/Actions';
import ActionButton from '@nextcloud/vue/dist/Components/ActionButton';
import { showError, showSuccess } from '@nextcloud/dialogs';
export default {
  name: 'Sidebar',
  components: {
    AppSidebar: AppSidebar,
    Actions: Actions,
    ActionButton: ActionButton
  },
  props: {
    showSidebar: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    sidebarStation: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    urlResolved: function urlResolved() {
      if (this.sidebarStation.url_resolved) {
        return this.sidebarStation.url_resolved;
      } else {
        return this.sidebarStation.urlresolved;
      }
    },
    stationTags: function stationTags() {
      if (this.sidebarStation.tags) {
        return this.sidebarStation.tags.replaceAll(',', ', ');
      }

      return '';
    }
  },
  methods: {
    toggleSidebar: function toggleSidebar(station) {
      this.$emit('toggleSidebar');
    },
    copyLink: function copyLink() {
      this.$copyText(this.urlResolved).then(function () {
        showSuccess(t('radio', 'Link copied to clipboard'));
      }, function () {
        showError(t('radio', 'Error while copying link to clipboard'));
      });
    }
  }
};